Application.Forms = {
    ready: function () {

        this.Validators.ready();
        this.Select.ready();
        this.FormControl.ready();
        this.ShowBy.ready();
        this.RadioImages.ready();
        this.CustomCheckboxes.ready();

    }
}